import gql from 'graphql-tag'

export const getProducers = gql`
  query($paging: PagingQuery, $order: ProducersOrder, $filter: ProducersFilter!) {
    getProducers(
      filter: $filter,
      order: $order,
      paging: $paging
    ) {
      producers {
        id
        name
        type
        producerCode
        title
        producerSubCode
        owedAmount
        phone
        email
        countryCode
        countryCallingCode
        extensionNumber
        newBusinessCommissionSplit
        renewalCommissionSplit
        username
        createdAt
        updatedAt
        lastModifiedBy {
          id
          username
        }
        createdBy {
          id
          username
        }
        partner{
          id
          name
        }
      }
      paging{ totalCount currentOffset currentLimit }
    }
  }
`

export const getCandidateProducers = gql`
  query($paging: PagingQuery, $filter: ProducersFilter!) {
    getProducers(
      filter: $filter,
      paging: $paging
    ) {
      producers {
        id
        name
      }
    }
  }
`

export const getProducer = gql`
  query($producerId: Int!) {
    getProducer(
      producerId: $producerId
    ) {
      id
      name
      type
      producerCode
      title
      producerSubCode
      owedAmount
      newBusinessCommissionSplit
      renewalCommissionSplit
      phone
      countryCode
      countryCallingCode
      extensionNumber
      email
      username
      createdAt
      updatedAt
      lastModifiedBy {
        id
        username
      }
      createdBy {
        id
        username
      }
      partner{
        id
        name
      }
      quotes {
        id
        name
        status
        type
        originalInceptionDate
        commissionPaymentEffectiveDate
        commissionPaymentExpirationDate
        currentCoverage
        currentPremium
        totalTermAmount
        closed
        createdAt
        updatedAt
        federalEmployerIdNumber
        additionalInfoStr
        caseId
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        source {
          id
          name
        }
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        recordType {
          id
          name
        }
        createdBy {
          id
          username
        }
        lastModifiedBy {
          id
          username
        }
      }
      policies {
        id
        policyName
        status
        closeDate
        effectiveDate
        expirationDate
        originalInceptionDate
        brokerFee
        agencyFee
        carrierPolicyFee
        inspectionFee
        taxesFee
        stampingFee
        premium
        policyNumber
        term
        closed
        bindDate
        payerType
        productCommissionOverride
        createdAt
        updatedAt
        caseId
        additionalInfoStr
        installmentPlan
        billingType
        isPremiumPayOff
        isCommissionPayOff
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        source {
          id
          name
        }
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        recordType {
          id
          name
        }
        insuranceQuote {
          id
          name
        }
      }
    }
  }
`

export const newProducer = gql`
  mutation($producerInput: ProducerInput!) {
    newProducer(
      producerInput: $producerInput
    ) {
      id,
      name
    }
  }
`

export const editProducer = gql`
  mutation($producerInput: ProducerInput!, $producerId: Int!) {
    editProducer(
      producerInput: $producerInput,
      producerId: $producerId
    ) {
      id
    }
  }
`

export const deleteProducer = gql`
  mutation($producerId: Int!) {
    deleteProducer(
      producerId: $producerId
    )
  }
`
